import { render, staticRenderFns } from "./ProductCell.vue?vue&type=template&id=4aa9dae3&"
import script from "./ProductCell.vue?vue&type=script&lang=js&"
export * from "./ProductCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports